export interface ProductReviewSummary {
  numberOfReviews: {
    total: number
    oneStar: number
    twoStars: number
    threeStars: number
    fourStars: number
    fiveStars: number
  }
  starsAverage: number
  attributes: {
    id: string
    name: string
    type: string
    source: string
    options: string[] | null
    totalOccurrences: number
    occurrences: {
      '1': number
      '2': number
      '3': number
      '4': number
      '5': number
    }
    average: number
  }[]
}

export interface ProductReview {
  id: string
  createdAt: string
  stars: number
  content: string
  consumer: {
    id: string
    displayName: string
  }
  language: string
  attributeRatings: {
    attributeId: string
    attributeName: string
    attributeType: string
    attributeOptions:
      | {
          id: string
          name: string
        }[]
      | null
    rating: number
  }[]
  attachments: {
    id: string
    state: string
    processedFiles: {
      dimension: string
      mimeType: string
      url: string
    }[]
  }[]
  firstCompanyComment: {
    comment: string
    createdAt: string
  } | null
}

const API_KEY = '0fzqrZ1mlBAqQ2L4XIrCsvxzg4l4YCDu'
const BUSINESS_UNIT_ID = '5df75011e5b7f100012e201f'

export async function loadProductReviews(
  skus: string[],
): Promise<{ summary: ProductReviewSummary; reviews: ProductReview[] }> {
  const reviewsRes = await (
    await fetch(
      `https://api.trustpilot.com/v1/product-reviews/business-units/${BUSINESS_UNIT_ID}/reviews?apikey=${API_KEY}&sku=` +
        skus.join(','),
    )
  ).json()

  const summaryRes = await (
    await fetch(
      `https://api.trustpilot.com/v1/product-reviews/business-units/${BUSINESS_UNIT_ID}?apikey=${API_KEY}&sku=` +
        skus.join(','),
    )
  ).json()

  return {
    summary: {
      attributes: summaryRes.attributes,
      numberOfReviews: summaryRes.numberOfReviews,
      starsAverage: summaryRes.starsAverage,
    },
    reviews: reviewsRes.productReviews,
  }
}
